var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.067 15a7 7 0 1 1-14 0 7 7 0 0 1 14 0m-1.155 6.844a9 9 0 1 1 1.365-1.456q.045.039.088.082l4.482 4.482c.488.488.567 1.2.176 1.59s-1.102.312-1.59-.176l-4.482-4.482z",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;